import axios from "axios";
import toast from "react-hot-toast";

export const internalApi = axios.create({
    baseURL: process.env.REACT_APP_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    }
});

const showErrorToast = (message) => {
    toast.error(message, {
        id: "unique-error-toast",
    });
}

internalApi.interceptors.response.use(
    response => response,
    error => {
        if (error.config?.skipErrorToast) {
            return Promise.reject(error);
        }
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    showErrorToast('세션이 만료되었습니다. 다시 로그인 해주세요.');
                    break;
                case 403:
                    showErrorToast('접근 권한이 없습니다.');
                    break;
                case 404:
                    showErrorToast('요청한 리소스를 찾을 수 없습니다.');
                    break;
                case 500:
                    showErrorToast('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
                    break;
                default:
                    const {message, details} = error.response.data || 'An unexpected error occurred';
                    showErrorToast(`${message}\n${details || ''}`);
                    break;
            }
        } else {
            toast.error('Network error. Please try again later.');
        }
        error.response.status = 200;
        return Promise.reject(error);
    }
);

internalApi.interceptors.request.use(
    request => request
)

export const analyticsApi = axios.create({
    baseURL: process.env.REACT_APP_ANALYTICS_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    }
})

analyticsApi.interceptors.request.use(
    request => request
)

analyticsApi.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            if (error.response.status === 401) {
                window.location.href = '/analytics/auth';
                toast.error('세션이 만료되었습니다. 다시 로그인 해주세요.');
            } else {
                const {message, details} = error.response.data || 'An unexpected error occurred';
                toast.error(`${message}\n${details || ''}`);
            }
        } else {
            toast.error('Network error. Please try again later.');
        }
        error.response.status = 200;
        return Promise.reject(error);
    }
);

export const OtherApi = axios.create({
    baseURL: '',
    headers: {
        "Content-Type": "application/json",
    }
});

export const gitlabApi = axios.create({
    baseURL: process.env.REACT_APP_GITLAB_URL,
    headers: {
        'Content-Type': 'application/json',
        'PRIVATE-TOKEN': process.env.REACT_APP_GITLAB_TOKEN,
    }
});

